import { apiPaths } from '../config/api-paths.js';
import request from '../utils/request.js';
import { stringifyQuery } from '../utils/query.js';
import type {
  ApiResponse,
  RequestResult,
  MainSession,
  MutablePayload,
} from '../types/domain.js';

export async function getSession(): Promise<RequestResult<MainSession>> {
  return request<MainSession>(apiPaths.adminSession);
}

export async function getssoLoginUrl(
  params: Readonly<Record<string, unknown>>,
): Promise<RequestResult<ApiResponse<string>>> {
  return request<ApiResponse<string>>(`${apiPaths.ssoLoginUrl}?${stringifyQuery(params)}`);
}

export async function schoolValidToken(
  params: MutablePayload,
): Promise<RequestResult<ApiResponse<unknown>>> {
  return request<ApiResponse<unknown>>(apiPaths.schoolValidToken, {
    method: 'POST',
    body: params,
  });
}

export async function ssoExchange(
  params: Readonly<Record<string, unknown>>,
): Promise<RequestResult<ApiResponse<unknown>>> {
  return request<ApiResponse<unknown>>(`${apiPaths.ssoExchange}?${stringifyQuery(params)}`);
}

export async function getSchoolSlugbyOrgCode(
  params: Readonly<Record<string, unknown>>,
): Promise<RequestResult<ApiResponse<{ schoolSlug: string }>>> {
  return request<ApiResponse<{ schoolSlug: string }>>(
    `${apiPaths.schoolSlugByOrgCode}?${stringifyQuery(params)}`,
  );
}

export async function getSchoolSlugbyID(
  params: Readonly<Record<string, unknown>>,
): Promise<RequestResult<ApiResponse<{ schoolSlug: string }>>> {
  return request<ApiResponse<{ schoolSlug: string }>>(
    `${apiPaths.schoolSlugByID}?${stringifyQuery(params)}`,
  );
}

export async function getSchoolInfoKS(
  params: MutablePayload,
): Promise<RequestResult<ApiResponse<{ SchoolId: string; UserRoleId: string }>>> {
  return request<ApiResponse<{ SchoolId: string; UserRoleId: string }>>(apiPaths.schoolInfoKS, {
    method: 'POST',
    body: params,
  });
}
